import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=404fad9f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404fad9f')) {
      api.createRecord('404fad9f', component.options)
    } else {
      api.reload('404fad9f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=404fad9f&", function () {
      api.rerender('404fad9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0DZVpOGwPYV/JS/offershelp.vue"
export default component.exports